import axios from "axios";
import { Method } from "./Constants";

export async function fetchToolsData(token: string): Promise<any> {
  try {
    const response = await axios({
      method: Method.GET,
      url: `${process.env.REACT_APP_TOOLDETAILS_API}`,
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_SUBSCRIPTION_KEY}`,
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error: any) {
    console.error("Error API FetchData", error.response.data);
    return error.response;
  }
}
